import axios from '../axios';
// 其他入库单列表
export const getStkInOtherPage = data => {
  return axios({
    url: '/api/sys/stk/getStkInOtherPage',
    method: 'post',
    data
  })
};
// 其他入库总合计
export const getStkInOtherSum = data => {
  return axios({
    url: '/api/sys/stk/getStkInOtherSum',
    method: 'post',
    data
  })
};

// 其他入库单列表保存
export const saveStkInOther = data => {
  return axios({
    url: '/api/sys/stk/saveStkInOther',
    method: 'post',
    data
  })
};

// 其他入库单列表修改
export const updateStkInOther = data => {
  return axios({
    url: '/api/sys/stk/updateStkInOther',
    method: 'post',
    data
  })
};

// 其他入库单列表删除
export const deleteStkInOthers = data => {
  return axios({
    url: '/api/sys/stk/deleteStkInOthers',
    method: 'post',
    data
  })
};

// 其他入库单列表查单条
export const getStkInOther = data => {
  return axios({
    url: '/api/sys/stk/getStkInOther',
    method: 'post',
    data
  })
};

// 其他入库单列表审核
export const auditStkInOthers = data => {
  return axios({
    url: '/api/sys/stk/auditStkInOthers',
    method: 'post',
    data
  })
};
// 其他入库单列表反审核
export const unauditStkInOthers = data => {
  return axios({
    url: '/api/sys/stk/unauditStkInOthers',
    method: 'post',
    data
  })
};

// 其他入库单列表作废
export const cancelStkInOthers = data => {
  return axios({
    url: '/api/sys/stk/cancelStkInOthers',
    method: 'post',
    data
  })
};


// 其他入库单明细列表
export const getStkInOtherEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkInOtherEntryPage',
    method: 'post',
    data
  })
};
// 其他入库单明细列表删除
export const deleteStkInOtherEntrys = data => {
  return axios({
    url: '/api/sys/stk/deleteStkInOtherEntrys',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/Warehous.js